import React from 'react';
import { Box, TextField, Typography, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox } from '@mui/material';

import useEmailEditorStore from '../../utilities/emailEditorStore';
import TypographyProps from './common/TypographyProps';
import BlockProps from './common/BlockProps';

function TextBlockProperties({ blockId }) {
  const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
  // Get the current block data from the store
  const block = getBlockById(blockId);
  
  if (!block) {
    return <Typography>Block not found</Typography>;
  }
  
  // Provide default properties if properties is undefined
  const properties = block.properties || {};

  // Generic property change handler
  const handlePropertyChange = (propertyName, value) => {
    updateBlockProperties(blockId, { [propertyName]: value });
  };

 
  return (
    <>
      <TextField
        fullWidth
        multiline
        rows={4}
        label="Text Content"
        value={properties.content || ''}
        onChange={(e) => handlePropertyChange('content', e.target.value)}
        sx={{ mb: 2 }}
      />
      
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>HTML Tag</InputLabel>
        <Select
          value={properties.htmlTag || 'p'}
          label="HTML Tag"
          onChange={(e) => handlePropertyChange('htmlTag', e.target.value)}
        >
          <MenuItem value="p">Paragraph (p)</MenuItem>
          <MenuItem value="div">Division (div)</MenuItem>
          <MenuItem value="span">Span (span)</MenuItem>
          <MenuItem value="pre">Preformatted (pre)</MenuItem>
        </Select>
      </FormControl>
      
      <FormControlLabel
        control={
          <Checkbox
            checked={properties.useStrong || false}
            onChange={(e) => handlePropertyChange('useStrong', e.target.checked)}
          />
        }
        label="Use Strong Tag (Bold)"
        sx={{ mb: 2 }}
      />
      
      <Box>
       <TypographyProps properties={properties} onPropertyChange={handlePropertyChange} />
       <BlockProps properties={properties} onPropertyChange={handlePropertyChange} />
      </Box>
    </>
  );
}

export default TextBlockProperties;